// Single source of truth for StoreDetailPage's tab values, so deep links can't drift from what it renders.
export const STORE_DETAIL_TABS = [
  "analytics",
  "appointments",
  "events",
  "menu",
  "target-deals",
  "bundle-deals",
  "multi-buy-deals",
  "point-rewards",
  "stamp-rewards",
  "referral-program",
  "activity",
  "merchant-activity",
  "staff",
] as const;

export type StoreDetailTab = (typeof STORE_DETAIL_TABS)[number];

// Named handles for each tab, derived from STORE_DETAIL_TABS so call sites can't drift from it.
export const [
  TAB_ANALYTICS,
  TAB_APPOINTMENTS,
  TAB_EVENTS,
  TAB_MENU,
  TAB_TARGET_DEALS,
  TAB_BUNDLE_DEALS,
  TAB_MULTI_BUY_DEALS,
  TAB_POINT_REWARDS,
  TAB_STAMP_REWARDS,
  TAB_REFERRAL_PROGRAM,
  TAB_ACTIVITY,
  TAB_MERCHANT_ACTIVITY,
  TAB_STAFF,
] = STORE_DETAIL_TABS;

export function isStoreDetailTab(value: string): value is StoreDetailTab {
  return (STORE_DETAIL_TABS as readonly string[]).includes(value);
}

export function storeDetailPath(storeId: string, tab?: StoreDetailTab): string {
  return tab ? `/stores/${storeId}?tab=${tab}` : `/stores/${storeId}`;
}
